var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', [_c('v-data-table', {
    attrs: {
      "items": _vm.buyers,
      "headers": _vm.headers,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.companyName",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.companyName[_vm.$i18n.locale]) + " ")];
      }
    }, {
      key: "item.activityAreas",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.activityAreas[_vm.$i18n.locale]) + " ")];
      }
    }, {
      key: "item.introductions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, _vm._l(item.introductions, function (introduction, index) {
          return _c('v-col', {
            key: index,
            staticClass: "pa-0 pr-2",
            attrs: {
              "cols": "auto"
            }
          }, [introduction[_vm.$i18n.locale] ? _c('v-icon', {
            attrs: {
              "color": "primary"
            },
            on: {
              "click": function click($event) {
                return _vm.download(introduction[_vm.$i18n.locale]);
              }
            }
          }, [_vm._v(_vm._s(_vm.mdiArrowDownThinCircleOutline))]) : _vm._e()], 1);
        }), 1)];
      }
    }])
  }), _c('pagination-component', {
    staticClass: "mt-3",
    attrs: {
      "count": _vm.pageCount
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }